import { render, staticRenderFns } from "./insectLamp.vue?vue&type=template&id=15ecd6c0&scoped=true&"
import script from "./insectLamp.vue?vue&type=script&lang=js&"
export * from "./insectLamp.vue?vue&type=script&lang=js&"
import style0 from "./insectLamp.vue?vue&type=style&index=0&id=15ecd6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ecd6c0",
  null
  
)

export default component.exports